module.exports = __webpack_public_path__ + "img/TMBTHANACHART.7d10f101.png";